import { TSLDRLatout } from "../type";
import ApplicationDocumentSelector from "cms/utilities/ApplicationDocumentSelector";
import { EResourceType } from "cms/enums/EResourceType";
import CoreDefault from "core/Defaults";
import IApplicationDocument from "cms/interfaces/IApplicationDocument";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import ILanguageVersionDetail from "cms/interfaces/ILanguageVersionDetail";
import { EView } from "cms/enums/EView";
import { EViewType } from "cms/enums/EViewType";


function SLDR_002 ( props: TSLDRLatout ) {
    console.log("SLDR_002: ", props);
    
    const video = ApplicationDocumentSelector<IApplicationDocument|null>({
        resources: props.payload.resources,
        resourceType: EResourceType.VIDEO,
        type: "find"
    });

    const languageVersion = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.siteSettingPayload.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION }
        ],
        type: "find"
    });

    return (
        <div className="swiper-slide">
            <video 
                className="main-slider-three__bg !tw-max-w-none !tw-h-auto 2xl:!tw-w-full tw-object-fill !tw-transform-none" 
                src={`${CoreDefault.cdn}/${video?.filePath}`} 
                autoPlay 
                preload="none" 
                muted 
                loop 
                title={languageVersion?.name||""}
            />
        </div>
    );
}


export default SLDR_002;
